import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Game } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetGameDetailsBySlug } from "../../api-clients/gamesClient";

interface UseGameDetailsBySlugQueryParams {
  slug: string;
  enabled?: boolean;
}

function useGameDetailsBySlugQuery({
  slug,
  enabled,
}: UseGameDetailsBySlugQueryParams): UseQueryResult<Game, Error> {
  const query = useQuery({
    queryKey: [QUERY_KEYS.GAME.GAME_DETAILS, slug],
    queryFn: () => handleGetGameDetailsBySlug(slug),
    enabled: !!slug && enabled,
  });

  return query;
}
export default useGameDetailsBySlugQuery;
